import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import type { Option } from 'modules/core/components/Popover/Content'

import Actions from 'modules/processes/components/ItemWizard/components/FilesList/FileListItem/Actions'
import type { TaskConfigurationAttachments } from 'modules/processes/components/ItemWizard/components/FilesList/types'

interface Props {
  file: TaskConfigurationAttachments | File
  options: Option[]
}

const FileListItem = ({ options, file }: Props) => {
  const fileName = 'filename' in file ? file.filename : file.name

  return (
    <Box
      width="full"
      flexDirection="row"
      padding="s16"
      alignItems="center"
      justifyContent="spaceBetween"
      gap="s12"
    >
      <Box gap="s8" flexDirection="row">
        <Icon.Medium icon="duplicate" />
        <Text.Normal color="grey800" overflowWrap>
          {fileName}
        </Text.Normal>
      </Box>
      <Actions options={options} />
    </Box>
  )
}

export default FileListItem
